import { parseNoteFailedErrorCode } from '@/features/note-generation/parseNoteFailedErrorCode';

const HTTP_5XX_CODE = /^HTTP_5\d\d$/;

/**
 * True when the consult-note stream request was answered with an untyped 5xx.
 * On v2.1 a backend `detail.type` keeps its own handling; v2.2's
 * `handleStreamOpen` drops the body, so every v2.2 5xx counts as untyped.
 */
export const isStreamServiceUnavailableFailure = (error: unknown): boolean =>
  HTTP_5XX_CODE.test(parseNoteFailedErrorCode(error));
